module.exports = __webpack_public_path__ + "img/2_2_3__4.8012e8f5.png";